import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import SearchBar from "../../components/inputs/SearchBar";
import { RxCaretDown, RxCaretRight } from "react-icons/rx";
import dummyUserProfile from "../../assets/dummy-profile-photo.png";
import { profileOptions, userProfileOptions } from "../../dummyData";
import ProfileOptionsCard from "../../components/cards/ProfileOptionsCard";
import { useState } from "react";
import PersonalInformationModal from "../../components/modals/PersonalInformationModal";
import LanguageSelectModal from "../../components/modals/LanguageSelectModal";
import ChangePassword from "../../components/modals/ChangePassword";
import GetPremium from "../../components/modals/GetPremium";
import TermsAndConditions from "../../components/modals/TermsAndConditions";
import AboutUs from "../../components/modals/AboutUs";
import { useParams, useSearchParams } from "react-router-dom";
import CancelPremium from "../../components/modals/CancelPremium";
import { useSelector } from "react-redux";
import NotificationSettings from "../../components/modals/NotificationSettings";
import WriteFeedback from "../../components/modals/WriteFeedback";
import { useProfileHooks } from "../../hooks/userProfileHooks";
import { useTranslation } from "../../languages";

const Profile = ({ onLogout }) => {
  const [params] = useSearchParams();
  const shouldOpenSettings = params.get("open");
  const [userData, setUserData] = useState({ name: "John Doe" });
  const [personalInfoModalOpen, setPersonalInfoModalOpen] = useState(
    shouldOpenSettings ? true : false
  );
  const [languageModalOpen, setLanguageModalOpen] = useState(false);
  const [premiumModalOpen, setPremiumModalOpen] = useState(false);
  const [termsAndConditionsOpen, setTermsAndConditonsOpen] = useState(false);
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  const [isSubscribedToPremium, setisSubscribedToPremium] = useState(false);
  const [subscribedModalOpen, setSubscribedModalOpen] = useState(false);
  const [notificationSettingsOpen, setNotificationSettingsOpen] =
    useState(false);
  const [feedbackModalOpen, setfeedbackModalOpen] = useState(false);
  const user = useSelector((s) => s?.user ?? {});
  const optionsToShow =
    user?.roles?.[0] === "user" ? userProfileOptions : profileOptions;
  const { t } = useTranslation();

  const openCorrespondingModal = (title) => {

    if (title === "personalInformation") setPersonalInfoModalOpen(true);
    if (title === "changePassword") setChangePasswordModalOpen(true);
    if (title?.toUpperCase() === "PREMIUM")
      {
        isSubscribedToPremium
        ? setSubscribedModalOpen(true)
        : setPremiumModalOpen(true);
      }
    if (title === "termsAndConditions") setTermsAndConditonsOpen(true);
    if (title === "aboutUs") setAboutUsOpen(true);
    if (title === "notification") setNotificationSettingsOpen(true);
    if (title === "feedback") setfeedbackModalOpen(true);
    if (title === "logOut") onLogout();
  };

  const {
    //all redux
    user_redux,
    //change password modal

    //all local states
    passwords,
    setPasswords,
    changePasswordModalOpen,
    setChangePasswordModalOpen,

    //all functions
    onPressSaveBtn,

    //info modal

    //all local states
    personalDetails,
    setPersonalDetails,

    //all functions
    onPressPerosnalInfoSaveBtn,
  } = useProfileHooks(setPersonalInfoModalOpen);

  console.log("user images", user_redux);

  const language_Redux = useSelector((s) => s?.language ?? "");
  console.log({ language_Redux });

  return (
    <div>
      <Container fluid>
        <h4 className="f-7 py-3 color-primary-black-2 mb-1">
          {t("myProfile")}
        </h4>
        <div className="d-flex align-items-center flex-wrap gap-2 justify-content-end">
          {/* <div style={{ minWidth: "80%" }}>
            <SearchBar />
          </div> */}

          <Button
            onClick={() => setLanguageModalOpen(true)}
            className="bg-white px-3  f-5 border-none double-shadow d-flex align-items-center gap-3 py-2 color-primary-blue "
          >
            {language_Redux?.name ?? "English"}
            <RxCaretDown size={30} />
          </Button>
        </div>
        <div className="bg-white p-3 mt-4" style={{ borderRadius: "15px" }}>
          <div className="text-center mt-3 mb-4">
            <img
              src={user_redux?.profilePicture}
              height={130}
              width={130}
              className="avatar"
            />
            <h4 className="mb-0 mt-3 f-6">
              {user_redux?.name?.first + " " + user_redux?.name?.last}
            </h4>
          </div>
          <Row className=" mb-3 py-0 justify-content-center">
            <Col md={11}>
              {optionsToShow?.map((item, key) => {
                return (
                  <ProfileOptionsCard
                    key={key}
                    onClick={() => openCorrespondingModal(item?.titleKey)}
                    icon={item?.icon}
                    className={key < optionsToShow?.length - 1 ? "mb-3" : ""}
                    title={t(item?.titleKey)}
                  />
                );
              })}
            </Col>
          </Row>
        </div>

        {/* personal info modal */}
        <PersonalInformationModal
          isOpen={personalInfoModalOpen}
          setisOpen={setPersonalInfoModalOpen}
          personalDetails={personalDetails}
          setPersonalDetails={setPersonalDetails}
          onPressSaveBtn={onPressPerosnalInfoSaveBtn}
        />
      </Container>

      {/* language select */}
      <LanguageSelectModal
        isOpen={languageModalOpen}
        setModalOpen={setLanguageModalOpen}
      />
      {/* change password mdoal */}
      <ChangePassword
        modalOpen={changePasswordModalOpen}
        setModalOpen={setChangePasswordModalOpen}
        passwords={passwords}
        setPasswords={setPasswords}
        onPressSaveBtn={onPressSaveBtn}
      />
      {/* premium modal open */}
      <GetPremium
        onSuccess={() => setisSubscribedToPremium(true)}
        modalOpen={premiumModalOpen}
        setModalOpen={setPremiumModalOpen}
      />

      {/* cancel premium modal */}
      <CancelPremium
        onCancel={() => setisSubscribedToPremium(false)}
        modalOpen={subscribedModalOpen}
        setModalOpen={setSubscribedModalOpen}
      />

      {/* terms and condtions */}
      <TermsAndConditions
        modalOpen={termsAndConditionsOpen}
        setModalOpen={setTermsAndConditonsOpen}
      />
      {/* about us  */}
      <AboutUs
        onFeedback={() => setfeedbackModalOpen(true)}
        modalOpen={aboutUsOpen}
        setModalOpen={setAboutUsOpen}
      />

      {/* notification  */}
      <NotificationSettings
        isOpen={notificationSettingsOpen}
        setisOpen={setNotificationSettingsOpen}
      />
      {/* feedback modal */}
      <WriteFeedback
        isOpen={feedbackModalOpen}
        setisOpen={setfeedbackModalOpen}
      />
    </div>
  );
};

export default Profile;
